import React, { FC, useState } from "react";
import { Page } from "../../commons/layout/Page.js";
import { Box, Grid } from "@mui/material";
import { CardContainer } from "@msys/ui";
import { PageContainer } from "../../commons/layout/PageContainer.js";
import { Tabs } from "@msys/ui";
import { PageSectionHeader } from "../../commons/layout/PageSectionHeader.js";

export const ExampleLayoutSettings: FC = () => {
  const [quickFilter, setQuickFilter] = useState<string>("General");
  return (
    <>
      <Page>
        <PageContainer>
          <PageSectionHeader title="Account settings" sx={{ mb: 1 }} />
          <Box
            sx={{
              mb: 2,
            }}
          >
            <Tabs
              value={quickFilter}
              onChange={setQuickFilter}
              options={[
                { value: "General", label: "General" },
                { value: "Account", label: "Account" },
                { value: "Print", label: "Print" },
                { value: "Shop", label: "Shop" },
              ]}
            />
          </Box>
          {quickFilter === "General" && (
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  lg: 4,
                }}
              >
                <CardContainer title="Services">
                  <Box
                    sx={{
                      height: 400,
                    }}
                  />
                </CardContainer>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  lg: 8,
                }}
              >
                <CardContainer title="About">
                  <Box
                    sx={{
                      height: 600,
                    }}
                  />
                </CardContainer>
              </Grid>
            </Grid>
          )}
          {quickFilter === "Account" && (
            <Grid container spacing={2}>
              <Grid size={12}>
                <CardContainer title="Settings">
                  <Box
                    sx={{
                      height: 400,
                    }}
                  />
                </CardContainer>
              </Grid>
            </Grid>
          )}
          {quickFilter === "Print" && (
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  lg: 4,
                }}
              >
                <CardContainer title="Column #1">
                  <Box
                    sx={{
                      height: 200,
                    }}
                  />
                </CardContainer>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  lg: 4,
                }}
              >
                <CardContainer title="Column #2">
                  <Box
                    sx={{
                      height: 400,
                    }}
                  />
                </CardContainer>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  lg: 4,
                }}
              >
                <CardContainer title="Column #3">
                  <Box
                    sx={{
                      height: 300,
                    }}
                  />
                </CardContainer>
              </Grid>
            </Grid>
          )}
          {quickFilter === "Shop" && (
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  lg: 6,
                }}
              >
                <CardContainer title="Merchant">
                  <Box
                    sx={{
                      height: 500,
                    }}
                  />
                </CardContainer>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  lg: 6,
                }}
              >
                <CardContainer title="Templates">
                  <Box
                    sx={{
                      height: 300,
                    }}
                  />
                </CardContainer>
              </Grid>
            </Grid>
          )}
        </PageContainer>
      </Page>
    </>
  );
};
